import React from 'react';

import { CuratedLoadedType, CuratedPageType } from './types';
import { FeaturedResourcesLayout } from 'components/FeaturedResources/constants';
import { MaturityModelCtaType } from 'components/MaturityModels/types';
import { RichTextFont } from 'components/RichText/constants';
import { SignupReminder } from 'components/SignupReminder';
import * as Layout from 'components/Layout';
import ContentTypesList from 'components/ContentTypeList';
import FeaturedResources from 'components/FeaturedResources';
import KeyTemplates from 'components/KeyTemplates';
import MaturityModels from 'components/MaturityModels';
import Publications from './components/Publications';
import RichText from 'components/RichText';

import styles from './styles.module.scss';
import Skeleton from './Skeleton';
import { ContentModel } from 'components/CMSModals/contentModal';
import { htmlSafe } from 'modules/utils/utils';

type TemplateProps = {
  curatedPage?: any;
  displaySignupReminder: boolean;
  loaded: CuratedLoadedType;
  mmCta: MaturityModelCtaType;
};

const Template: React.FunctionComponent<TemplateProps> = ({
  curatedPage,
  displaySignupReminder,
  loaded,
  mmCta,
}) => {
  return (
    <Layout.Container className={styles.curatedPage}>
      <Layout.Content>
        {loaded.curatedPage ? (
          <div>
            <h1>{curatedPage?.contentTitle}</h1>
            {curatedPage && curatedPage.paragraphModels[0].paraText && (
              <p className={styles.description}>
                {htmlSafe(curatedPage.paragraphModels[0].paraText)}
              </p>
            )}
          </div>
        ) : (
          <Skeleton />
        )}
        <FeaturedResources
          data={
            curatedPage?.multipleObjectParentModels[1].socialMediaCardModels
          }
          layout={FeaturedResourcesLayout.ROW}
          loaded={loaded.curatedPage}
          showCta={false}
          title={
            curatedPage?.contentTitle === 'ITIL 4 Practices'
              ? curatedPage?.contentTitle
              : 'Key Content'
          }
        />
        {/* <ContentTypesList
        // data={curatedPage?.content_types.curated_content_types}
        // loaded={loaded.curatedPage}
        // title={curatedPage?.content_types.label}
        /> */}
        {/* <RichText
          className={styles.richText}
          // content={curatedPage?.rich_text}
          font={RichTextFont.SECONDARY}
          //loaded={loaded.curatedPage}
        /> */}
        {displaySignupReminder && <SignupReminder />}
      </Layout.Content>
      <Layout.Sidebar>
        <MaturityModels
          loaded={loaded.curatedPage}
          maturityModelsUrl={mmCta}
          mm_section={curatedPage?.mm_section}
        />
        {/* <KeyTemplates
        // keyTemplates={curatedPage?.curate_key_templates.key_templates_list}
        // loaded={loaded.curatedPage}
        // title={curatedPage?.curate_key_templates?.label}
        /> */}
        {curatedPage && (
          <Publications
            loaded={loaded.curatedPage}
            publications={
              curatedPage?.publications?.publications_links
                ? curatedPage?.publications?.publications_links
                : []
            }
            title={
              curatedPage?.publications?.label
                ? curatedPage?.publications?.label
                : ''
            }
          />
        )}
      </Layout.Sidebar>
    </Layout.Container>
  );
};

export default Template;
